import React, { useRef, useState } from "react";
import TextBox from './TextBox';

export function SupplyOwnFabric({ fabricData, setFabricData, errors, handleInputChange  }) {
    const haveSupplyOwnFabricPatternRepeat = useRef(!!fabricData.supplyOwnFabricPatternRepeat).current;

    return (
        <div className="mb-24">
            <div className="body-text3">Your Fabric Name Or Description:</div>
            <div className="body-text6 gray mt-12 max-width-460">
                If the fabric you like is not on our website, please email or call us on <a href="tel:0345 8620743" className="underline">0345 8620743</a> as we maybe able to source it for you at a competitive price. 
            </div>

            <div>
                {/* Description */}
                <div className="mt-16 no-input-group">
                    <TextBox
                        name="supplyOwnFabricNameOrDescription"
                        value={fabricData.supplyOwnFabricNameOrDescription}
                        onChange={handleInputChange}
                    />
                    {errors.supplyOwnFabricNameOrDescription && (
                        <span className="field-validation-error">{errors.supplyOwnFabricNameOrDescription}</span>
                    )}
                </div>

                {/* Vertical Pattern Repeat and Fabric Roll Width */}
                <div className="mt-24 two-columns sm-column sm-gap-24">
                    {
                        haveSupplyOwnFabricPatternRepeat && (                                    
                            <div>
                                <div className="body-text6 align-center gap-8">
                                    <span>Vertical Pattern Repeat:</span>
                                    <span className="curtains-icon curtains-icon-Info-circle size-24 gray"></span>
                                </div>
                                <div className="mt-8">
                                    <TextBox
                                        name="supplyOwnFabricPatternRepeat"
                                        value={fabricData.supplyOwnFabricPatternRepeat}
                                        onChange={handleInputChange}
                                        unit={fabricData.unitOfMeasurement==0? 'cm':'inches'}
                                    />
                                    {errors.supplyOwnFabricPatternRepeat && (
                                        <span className="field-validation-error">{errors.supplyOwnFabricPatternRepeat}</span>
                                    )}
                                </div>
                            </div>
                        )
                    }

                    <div>
                        <div className="body-text6 align-center gap-8 line-height-24">
                            <span>Fabric (Roll) Width:</span>
                        </div>
                        <div className="mt-8">
                            <TextBox
                                name="supplyOwnFabricRollWidth"
                                value={fabricData.supplyOwnFabricRollWidth}
                                onChange={handleInputChange}
                                unit={fabricData.unitOfMeasurement==0? 'cm':'inches'}
                            />
                            {errors.supplyOwnFabricRollWidth && (
                                <span className="field-validation-error">{errors.supplyOwnFabricRollWidth}</span>
                            )}
                        </div>
                    </div>
                </div>

                <hr className="secodary-line mt-24 mb-16" />
            </div>
        </div>
    );
}
